module.exports = __webpack_public_path__ + "img/dete.0a9ab4b1.jpg";